// extracted by mini-css-extract-plugin
module.exports = {"filter":"cutbYKM1S09kv55teBFQ"};